<div class="stripe-manual-container">
    <div *ngIf="loading" class="loading-container">
        <div class="loading-spinner">Loading payment form...</div>
    </div>

    <div
        class="stripe-form-container"
        [style.display]="loading ? 'none' : 'block'"
    >
        <div
            [id]="elementId"
            class="stripe-payment-element"
            data-testid="stripe-payment-element"
        ></div>
    </div>
</div>
